import { z } from 'zod';
/** Sums over passed and failed trials; divide by `trialCount` for per-trial means. */
export const EvaluationEfficiencyTotalsSchema = z.object({
    /** Null when any counted trial lacks the metric, such as an unpriced model or an older artifact. */
    cacheIndependentCostInUsd: z.number().nonnegative().nullable(),
    outputTokens: z.number().int().nonnegative(),
    toolCallCount: z.number().int().nonnegative(),
    /** Uncached, cache-read, and cache-write input tokens together. */
    totalInputTokens: z.number().int().nonnegative(),
    trialCount: z.number().int().nonnegative(),
    turnCount: z.number().int().nonnegative(),
});
/** Per-trial means averaged with equal weight per task that has at least one counted trial. */
export const EvaluationSuiteEfficiencySchema = z.object({
    /** Null when any counted task's cache-independent cost is null. */
    cacheIndependentCostInUsd: z.number().nonnegative().nullable(),
    outputTokens: z.number().nonnegative(),
    taskCount: z.number().int().nonnegative(),
    toolCallCount: z.number().nonnegative(),
    totalInputTokens: z.number().nonnegative(),
    turnCount: z.number().nonnegative(),
});
//# sourceMappingURL=evaluationEfficiency.js.map